﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class ExtendedAttributeClient {
    constructor(baseURL) {
        if (baseURL) {
            this.client = new OperationalContextClient_1.OperationalContextClient(baseURL);
        }
        else {
            this.client = new OperationalContextClient_1.OperationalContextClient();
        }
    }
    getAttributes(entityName, organizationAppId) {
        if (organizationAppId != null) {
            return this.client.apiExtendedattributeOrganizationByOrganizationAppIdByEntityNameGet(organizationAppId, entityName);
        }
        else {
            return this.getGlobalAttributes(entityName);
        }
    }
    getGlobalAttributes(entityName) {
        return this.client.apiExtendedattributeByEntityNameGet(entityName);
    }
    genericGetAllExtendedEntities() {
        return this.client.apiExtendedattributeGet();
    }
    genericExtendedAttributesUpdate(attribute) {
        return this.client.apiExtendedattributePut(attribute);
    }
    genericExtendedAttributesAdd(attribute) {
        return this.client.apiExtendedattributePost(attribute);
    }
    genericAttributesDelete(attribute) {
        return this.client.apiExtendedattributeDelete(attribute);
    }
}
exports.ExtendedAttributeClient = ExtendedAttributeClient;
//# sourceMappingURL=ExtendedAttributeClient.js.map